import { formatDecimal } from "./reportingSummaryUtils";
import { formatCurrency } from "../../utils/financialFormatters";

export function ReportingSummaryPlCell({
  value,
  currencySymbol = "$",
}: {
  value: number;
  currencySymbol?: string;
}) {
  const formatted = formatCurrency(value, currencySymbol, 2);
  if (value === 0) {
    return (
      <span className="reporting-summary-value reporting-summary-value--muted">
        {formatted}
      </span>
    );
  }
  // Positive P&L gets an explicit "+" to mirror the negative "-" the shared util already prepends.
  const display = value > 0 ? `+${formatted}` : formatted;
  const tone =
    value > 0
      ? "reporting-summary-value--positive"
      : "reporting-summary-value--negative";
  return <span className={`reporting-summary-value ${tone}`}>{display}</span>;
}

export function ReportingSummaryMarginCell({ value }: { value: number }) {
  const formatted = formatDecimal(value, 2);
  if (value === 0) {
    return (
      <span className="reporting-summary-value reporting-summary-value--zero">
        {formatted}%
      </span>
    );
  }
  const display = `${value > 0 ? "+" : ""}${formatted}%`;
  const tone =
    value > 0
      ? "reporting-summary-value--positive"
      : "reporting-summary-value--negative";
  return <span className={`reporting-summary-value ${tone}`}>{display}</span>;
}
